var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.cleanJson(_vm.extra_fields)),function(value,from){return _c('v-card',{key:from,staticClass:"mb-2"},[_c('v-card-text',{staticClass:"pa-2 border-bottom"},[_c('h3',{staticClass:"subtitle blue-grey--text text--darken-2 font-weight-regular"},[_vm._v(" Campos extra do "+_vm._s(from)+" ")])]),_c('v-card-text',{staticClass:"pa-5 border-bottom"},[_c('v-form',{attrs:{"id":"formDadosMotorista"}},[_c('v-row',_vm._l((value),function({ cols, ...args },key){return _c('v-col',_vm._b({key:key},'v-col',cols,false),[_c('v-text-field',_vm._b({attrs:{"value":_vm.getAtributoExtraField({
                  key: key,
                  from: from,
                })},on:{"input":function($event){return _vm.updateAtributoExtraField({
                  value: $event,
                  key: key,
                  from: from,
                })}}},'v-text-field',args,false))],1)}),1)],1)],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }